<template>
  <div class="widget-heading -list">
    <h1 class="textStyle">{{ $t("conditions.title") }}</h1>
  </div>
  <div class="widget-content">
    <div class="panel-body rounded-pills-icon tabs">
      <div class="alert alert-info mb-4" role="alert">
        <i class="fa fa-info-circle me-2"></i>
        {{ $t("conditions.alerte") }}
      </div>

      <FormComponent v-if="models" :models="models" @formSubmit="onSubmit" @formCancel="routerBack" />
    </div>
  </div>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import { formManager } from "@/services/form/form-manager";

export default {
  name: "TemplateEditConditionsComponent",
  components: {
    FormComponent,
  },
  props: {
    models: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onSubmit() {
      const response = formManager.processForm(this.models, false);
      this.$emit("formSubmit", response);
    },
    routerBack() {
      this.$emit("formCancel");
    },
  },
};
</script>
